import { useHistory } from 'react-router-dom';

import { useAuthenticationDataContext } from '../../Helpers/AuthenticationDataProvider';
import { useAuthorizationDataContext } from '../../Helpers/AuthorizationDataProvider';
import useFetchWrapper, { HttpResponse } from '../../Helpers/useFetchWrapper';

import { LoginData, LoginResponse } from './Login.model';

const useLogin = () => {
	const { setData: setAuthenticationData } = useAuthenticationDataContext();
	const { setData: setAuthorizationData } = useAuthorizationDataContext();

	const { post } = useFetchWrapper();
	const history = useHistory();

	const navigateTo = (path: string) => {
		history.push(path);
	}

	const onSubmitLogin = async (data: LoginData) => {
		const res: HttpResponse<LoginResponse> = await post('/user/authenticate', data, true);

		if (res.ok && res.parsedBody) {
			const {
				email,
				firstName,
				lastName,
				permissions,
				refreshToken,
				rocketAuthToken,
				rocketUserId,
				role,
				token,
				userId
			} = res.parsedBody;

			setAuthorizationData({
				permissions,
				role,
			});

			setAuthenticationData({
				email,
				firstName,
				lastName,
				refreshToken,
				rocketAuthToken,
				rocketUserId,
				token,
				userId,
			});
		}
	}

	return {
		navigateTo,
		onSubmitLogin,
	}
}

export default useLogin;